import $ from 'jquery';
import 'jquery-ui/ui/widgets/sortable';

function orderedIds(el) {
  return el.sortable('toArray', { attribute: 'data-id' });
}

$(() => {
  const sortableEl = $('.js-sortable');
  sortableEl.sortable().on('sortupdate', () => {
    $.ajax({
      url: sortableEl.data('url'),
      contentType: 'application/json',
      method: 'POST',
      data: JSON.stringify({ ordered_ids: orderedIds(sortableEl) }),
      success: () => {
        location.reload();
      },
    });
  });
});
